class IJModal {
    constructor(options) {
        this.title = options.title || '';
        this.description = options.description;
        this.data = options.data || {};
        this.type = options.type || '';
        this.template = options.template || 'basic';
        this.cssClass = options.cssClass || '';
		this.render();
    }

    render() {
        const modalContainer = document.createElement('div');
        modalContainer.classList.add('lg-popup__modal');
        modalContainer.innerHTML = this.loadTemplate(this.template);
        document.body.appendChild(modalContainer);

        const dialog = modalContainer.querySelector('dialog');

        dialog.showModal();

        // Add event listener to close button
        const closeBtn = modalContainer.querySelector('.close-btn');
        const btnsInsideModal = modalContainer.querySelectorAll('.wp-block-button__link'); //TODO: Change this selector to the correct one

        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                document.dispatchEvent(new CustomEvent('modalClosed'), { detail: {} });
                this.close(modalContainer);
            });
        }

        if(btnsInsideModal) {
            btnsInsideModal.forEach(btn => {
                btn.addEventListener('click', (event) => {
                    document.dispatchEvent(new CustomEvent('eventButtonModal', { detail: { event : event } } ));
                });
            });
        }
    }

    // Method to close the modal
    close(modalContainer) {
        const dialog = modalContainer.querySelector('dialog');
		if (dialog) {
			dialog.close();
			document.body.removeChild(modalContainer);
		}
    }

    // Method to get template based on template name
    loadTemplate(templateName) {
        const templates = {
            iframe:
            `
            <dialog class="ie-modal${ this.cssClass ? ' ' + this.cssClass : '' }">
                <button class="close-btn"><span class="icon icon--close"></span></button>
                <div class="ie-modal__content">
					${ ( '' != this.title) ? '<h2 class="ie-modal__title has-h-3-font-size">'+this.title+'</h2>' : '' }
                    <div>${this.description}</div>
                </div>
            </dialog>
            `,
        };
        return templates[templateName];
    }
}